<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/messages.json"></i18n>

<i18n>
    {
    "en": {
    "amo": {
    "account-title": "Account amoCRM"
    }
    },
    "ua": {
    "amo": {
    "account-title": "Акаунт amoCRM"
    }
    },
    "ru": {
    "amo": {
    "account-title": "Аккаунт amoCRM"
    }
    }
    }
</i18n>

<template>
  <el-main>
    <router-view
      v-if="customer && amocrm"
      :customer="customer"
      :amocrm-list="amocrm"
    />
    <div v-show="$route.name === 'customers.details'">
      <component
        :is="require('../_snippets/header_actions/header_actions').default"
      >
        <template slot="left-side">
          <el-button
            @click="
              $router.push({
                name: 'customers.details.installed_services',
                params: {}
              })
            "
            :disabled="edit_mode"
            >{{ $t("actions.show_services") }}
          </el-button>
        </template>
        <template slot="button-group">
          <el-button @click="merge_mode = true" :disabled="edit_mode">{{
            $t("actions.merge")
          }}</el-button>
          <el-button
            type="primary"
            :disabled="edit_mode"
            @click="handleNewElement('amocrm')"
            >{{ $t("actions.new_amo") }}
          </el-button>
          <el-button
            type="primary"
            :disabled="edit_mode"
            @click="handleNewElement('contacts')"
            >{{ $t("actions.new_contact") }}
          </el-button>
        </template>
      </component>

      <el-container class="cards">
        <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
          <el-card class="card-customer">
            <div slot="header" class="clearfix">
              <el-row
                type="flex"
                class="row-bg align-center"
                justify="space-between"
              >
                <span v-text="customer.name"></span>
                <template v-if="!curEdit">
                  <el-button-group>
                    <el-button
                      type="primary"
                      size="small"
                      :disabled="edit_mode"
                      @click="handleEdit('customer', customer.uuid)"
                      >{{ $t("actions.edit") }}
                    </el-button>
                  </el-button-group>
                </template>
                <template v-else>
                  <el-button-group>
                    <el-button
                      type="success"
                      size="small"
                      @click="handleSave('customer', customer.uuid)"
                      >{{ $t("actions.save") }}
                    </el-button>
                    <el-button type="primary" size="small" @click="handleCancel"
                      >{{ $t("actions.cancel") }}
                    </el-button>
                  </el-button-group>
                </template>
              </el-row>
            </div>
            <template v-if="curEdit">
              <el-form>
                <el-input v-model="customer.name"></el-input>
                <el-input
                  type="textarea"
                  v-model="customer.description"
                ></el-input>
              </el-form>
            </template>
            <div v-else-if="customer.description">
              {{ customer.description }}
            </div>
          </el-card>
        </el-row>

        <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
          <sub-element-amo
            class="card-amo"
            v-for="(a, i) in amocrm"
            :ref="'a::' + a.uuid"
            :key="'a' + a.uuid"
            :editMode.sync="edit_mode"
            v-model="amocrm[i]"
            @action="handleAction"
          >
            <template slot="actions.before.unlink_customer">
              <el-button
                size="small"
                type="info"
                :disabled="edit_mode"
                @click="
                  $router.push({
                    name: 'customers.details.installed_services',
                    params: { amo_id: a.uuid }
                  })
                "
                >{{ $t("actions.show_services") }}
              </el-button>
              <!--<el-button
                                size="small"
                                :disabled="edit_mode"
                                @click="handleShowServices(a.uuid)"
                            >{{$t("actions.show_services")}}
                            </el-button>-->
              <!--<el-button
                                type="info"
                                size="small"
                                :disabled="edit_mode"
                                @click="handleWidgets(a)"
                            >{{ $t("actions.widgets") }}
                            </el-button>-->
            </template>
          </sub-element-amo>
        </el-row>

        <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
          <sub-element-contact
            class="card-contact"
            v-for="(a, i) in contacts"
            :ref="'c::' + a.uuid"
            :key="'c' + a.uuid"
            :editMode.sync="edit_mode"
            v-model="contacts[i]"
            @action="handleAction"
          />
        </el-row>
      </el-container>

      <component
        :is="require('./elements/popup').default"
        :amo.sync="widgets_for"
        :customer="customer"
      />
      <merge_component :merge_mode.sync="merge_mode" />
      <component
        :is="require('../_snippets/popup/popup_912x616').default"
        :visible.sync="show_services"
      >
        <template slot="content" v-if="show_services && vars_services">
          <el-container>
            <el-main>
              <customers_services_list
                :request_vars="vars_services"
                is_in_customer_datails
              />
            </el-main>
          </el-container>
        </template>
      </component>
    </div>
  </el-main>
</template>

<script>
import { mapGetters } from "vuex";
import OpenInNewIcon from "icons/OpenInNew";
import Merge_component from "./elements/merge_component";
import Customers_services_list from "../services/services_list";
import SubElementContact from "../_snippets/sub_elements/sub-element-contact";
import SubElementAmo from "../_snippets/sub_elements/sub-element-amo";
import SharedAmocrm from "../../store/classes/SharedAmocrm";
import SharedContacts from "../../store/classes/SharedContacts";

export default {
  name: "customer_edit",
  components: {
    SubElementAmo,
    SubElementContact,
    Customers_services_list,
    Merge_component,
    OpenInNewIcon
  },
  data() {
    return {
      curEdit: null,
      schema: {
        amocrm: ["domain", "login", "secret_key", "account_id"],
        contacts: ["name", "email", "phone"]
      },
      curChanged: null,
      widgets_for: null,
      merge_mode: false,
      show_services: false,
      vars_services: null,
      edit_mode: false
    };
  },
  created() {
    if (this.$route.params.id === "new") {
      this.curEdit = { model: "customer", uuid: null };
    }
    this.getData();
  },
  methods: {
    getData() {
      this.$api.query(this.refetchQueries[0]);
    },
    editMode(model, uuid) {
      try {
        return this.curEdit.model === model && this.curEdit.uuid === uuid;
      } catch (e) {
        return false;
      }
    },
    handleEdit(model, uuid) {
      this.edit_mode = true;
      this.curEdit = true;
    },
    handleCancel() {
      this.edit_mode = false;
      this.curEdit = false;
      this.$notify.info("Canceled");
      this.getData();
    },
    handleSave(model, uuid) {
      let g = this.customerMutation;
      let message = "SharedCustomers saved";
      this.$api.mutate(g).then(res => {
        this.$log(res);
        this.$notify.success({
          title: "Success",
          message: message
        });
        if (this.$route.params.id === "new") {
          this.$router.replace({
            name: "customers.details",
            params: { id: res.data.shared_customers.uuid }
          });
        }
        this.curEdit = false;
        this.edit_mode = false;
      });
    },
    unlinkContact(uuid) {
      this.customer["sharedContacts_uuids"] = this.customer[
        "sharedContacts_uuids"
      ].filter(v => v !== uuid);
      this.$api
        .mutate(this.customerMutation)
        .then(() => {
          this.$notify.success({
            title: "Success",
            message: "Deleted customer relationship"
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "Not deleted"
          });
        });
    },
    handleNewElement(schema_name) {
      switch (schema_name) {
        case "amocrm":
          // eslint-disable-next-line no-case-declarations
          let new_amo = new SharedAmocrm({
            sharedCustomers_uuid: this.customer.uuid,
            confirmed: false
          });
          this.amocrm.push(new_amo);
          setTimeout(() => {
            this.$refs["a::" + new_amo.uuid][0].cur_edit_mode = true;
            this.edit_mode = true;
          }, 1);
          break;
        case "contacts":
          // eslint-disable-next-line no-case-declarations
          let new_contact = new SharedContacts({
            customer_uuid: this.customer.uuid
          });
          this.contacts.push(new_contact);
          setTimeout(() => {
            this.$refs["c::" + new_contact.uuid][0].cur_edit_mode = true;
            this.edit_mode = true;
          }, 1);
          break;
      }
    },
    handleWidgets(amo) {
      this.widgets_for = Object.assign({}, amo);
    },
    handleAction(action, status, model) {
      if (model instanceof SharedContacts) {
        switch (action) {
          case "unlink_customer":
            this.unlinkContact(model.uuid);
        }
      } else {
        this.customer._embedded = {};
        this.getData();
      }
    },
    handleCheckAmo(amo) {
      this.$log(amo._loading);
      amo._handleCheckAmo();
      this.$log(amo._loading);
    },
    handleShowServices(uuid = null) {
      this.vars_services = {
        customer: this.customer.uuid
      };
      if (uuid) {
        this.vars_services.amo = uuid;
      }
      this.$log(this.vars_services);
      this.show_services = true;
    }
  },
  computed: {
    ...mapGetters({
      customer: "shared_customers/customer",
      amocrm: "shared_customers/amocrm",
      contacts: "shared_customers/contacts"
    }),
    refetchQueries() {
      return [
        {
          query: require("../../graphql/customers/customer.graphql"),
          variables: { uuid: this.$route.params.id }
        }
      ];
    },
    customerMutation() {
      return {
        mutation: require("../../graphql/customers/customer_save.graphql"),
        variables: this.customer,
        refetchQueries: this.refetchQueries
      };
    }
  }
};
</script>

<style lang="stylus">
.el-form-item__label:after {
    content: ':';
}

.el-form-item__label {
    width: 85px;
    font-weight: bold;
}

.amo-info {
    cursor: pointer;
}

.card-new {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.align-center {
    align-items: center;
}
</style>

<style scoped lang="stylus">
.el-container.cards {
    flex-direction: column;
    margin-top: 2rem;
}

.card-contact, .card-amo, .card-customer {
    min-width: 400px;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
}

.row-bg {
    flex-wrap: wrap;
}
</style>
